import { createApi } from '@reduxjs/toolkit/query/react';

import { TagTypesEnum } from '@enum/tag-types.enum';
import {
  BillingCreateCheckoutInterface,
  BillingCreatePortalInterface,
  PaymentHistoryInterface,
  ProductInterface,
  SubscriptionInterface,
} from '@interface/billing/billing.interface';
import { ResponseDataInterface } from '@interface/logs/response-data.interface';
import { portalQueryAuth } from '@util/api/portal-query-auth';
import { isString } from '@util/data/is-exist';

export const billingApi = createApi({
  reducerPath: 'billing-api',
  tagTypes: [TagTypesEnum.Billing, TagTypesEnum.Payment, TagTypesEnum.Plans, TagTypesEnum.Subscription],
  baseQuery: portalQueryAuth('/billing'),
  endpoints: (build) => ({
    createCheckoutSession: build.mutation<ResponseDataInterface<BillingCreateCheckoutInterface>, string>({
      query: (plan) => ({ method: 'POST', url: `/checkout-session`, body: { plan } }),
    }),
    createCustomerPortal: build.mutation<ResponseDataInterface<BillingCreatePortalInterface>, void>({
      query: (body) => ({ method: 'POST', url: `/customer-portal`, body }),
      invalidatesTags: [TagTypesEnum.Subscription],
    }),
    loadPayments: build.query<ResponseDataInterface<PaymentHistoryInterface[]>, string>({
      query: (account) => ({ method: 'GET', url: `/transactions?account=${account}` }),
      providesTags: [TagTypesEnum.Payment],
    }),
    requestSubscription: build.mutation<ResponseDataInterface<void>, string>({
      query: (plan) => ({ method: 'POST', url: `/request-subscription`, body: { plan } }),
    }),
    switchSubscription: build.mutation<ResponseDataInterface<SubscriptionInterface>, string>({
      query: (plan) => ({ method: 'POST', url: `/switch-subscription`, body: { plan } }),
      invalidatesTags: [TagTypesEnum.Subscription],
    }),
    loadPlans: build.query<ResponseDataInterface<ProductInterface[]>, void>({
      query: () => ({ method: 'GET', url: `/plans` }),
      providesTags: [TagTypesEnum.Plans],
    }),
    loadSubscription: build.query<ResponseDataInterface<SubscriptionInterface>, string | undefined>({
      query: (application) => ({
        method: 'GET',
        url: `/subscription${isString(application) ? `?account=${application}` : ''}`,
      }),
      providesTags: [TagTypesEnum.Subscription],
    }),
  }),
});
